module.exports = require('./helpers/bundle-url').getBundleURL('19kb1') + "logo-dark.ba5147f0.svg";